<template>
  <div class="filter-control">
    <input
      type="text"
      class="form-control"
      :placeholder="label"
      v-model="filter"
    />
    <span v-if="filter" class="fa-solid fa-xmark filter-clear" v-on:click="clear"></span>
  </div>
</template>
<script>
import debounce from "@/util/debounce";

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: "Search",
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    filter: {
      get: function() {
        return this.modelValue;
      },
      set: function(filter) {
        this.filterChanged(filter);
      },
    },
  },
  created: function() {
    const vm = this;
    this.filterChanged = debounce(function(filter) {
      this.logDebug("Filter applied", { filter });
      vm.$emit("update:modelValue", filter);
    }, 500);
  },
  methods: {
    clear: function() {
      this.$emit("update:modelValue", "");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../_css/variables";

.filter-control {
  position: relative;

  & input {
    padding-right: 30px;
  }

  & .filter-clear {
    position: absolute;
    top: 11px;
    right: 15px;
    color: $gray-600;

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
}

</style>
